import axiosInstance from './interceptor.tsx'
import { IssuerDto } from '../components/shared/types'

export const IssuersApi = {
  getIssuers: async (): Promise<IssuerDto[]> => {
    try {
      const result = await axiosInstance.get<IssuerDto[]>('/issuers')
      return Array.isArray(result.data) ? result.data : []
    } catch (error) {
      console.error('Error fetching issuers:', error)
      throw error
    }
  },
}
